import { matchPath } from 'react-router-dom-v5-compat';

const root = '/pro/my_money/business_financing';
const chargeCardRoot = '/pro/my_money/charge_card';

export const businessFinancingPaths = Object.freeze({
  root,
  fundbox: `${root}/line_of_credit`,
  stripeCapital: `${root}/financial_offer`,
  chargeCard: {
    root: chargeCardRoot,
    transactions: `${chargeCardRoot}/transactions`,
  },
});

export const businessFinancingNavItemValues = Object.freeze({
  root: 'business_financing',
  fundbox: `business_financing_line_of_credit`,
  stripeCapital: `business_financing_financial_offer`,
  chargeCard: {
    root: `charge_card`,
    transactions: `charge_card_transactions`,
  },
});

export const isBusinessFinancingRoot = (pathname: string) => matchPath(businessFinancingPaths.root, pathname);
export const isBusinessFinancingFundbox = (pathname: string) => matchPath(businessFinancingPaths.fundbox, pathname);
export const isBusinessFinancingStripeCapital = (pathname: string) =>
  matchPath(businessFinancingPaths.stripeCapital, pathname);
export const isChargeCardRoot = (pathname: string) => matchPath(businessFinancingPaths.chargeCard.root, pathname);
export const isChargeCardTransactions = (pathname: string) =>
  matchPath(businessFinancingPaths.chargeCard.transactions, pathname);
